var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-file-selector"},[_vm._t("default",function(){return [_vm._v("select files")]},null,{ files: _vm.files }),_c('input',_vm._b({staticClass:"ui-file-selector-input pos-abs pos-top-left w-100 h-100",attrs:{"type":"file"},on:{"change":_vm.onFilesChanged}},'input',{ accept: _vm.accept, multiple: _vm.multiple },false))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }